import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  FaArrowLeft,
  FaCoins,
  FaExclamationCircle,
  FaEye,
  FaPlusCircle,
  FaTrash,
  FaWallet,
} from "react-icons/fa";
import { useNavigate } from "react-router";
import moment from "moment";
import { getAllTopupRequests } from "./services/topup.services";
import ExpandableText from "../../components/explandabletext/ExpandableText";
import TopupReqDelete from "./TopupReqDelete";
import { getWalletBalance } from "../wallet/services/wallet.services";

const Topup = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // default date filters
  const firstDay = moment().startOf("month").format("YYYY-MM-DD");
  const today = moment().format("YYYY-MM-DD");

  const [deleteID, setDeleteID] = useState(null);

  const [filters, setFilters] = useState({
    fromDate: firstDay,
    toDate: today,
    status: "",
  });

  const topups = useAppSelector((state) => state.topup.TopupRequestList);
  const loading = useAppSelector((state) => state.topup.loading);
  const walletDetails = useAppSelector((state) => state.wallet.walletDetails);

  // initial load
  useEffect(() => {
    handleView(filters);
    dispatch(getWalletBalance());
  }, []);

  const handleFilterChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleView = (filters: any) => {
    const payload = {
      FromDate: filters.fromDate || null,
      ToDate: filters.toDate || null,
      RequestStatus: filters.status || "",
      MobileNo: localStorage.getItem("mobile_no") || "",
      DepositedBank: "",
      Name: "",
      FromAmount: 0,
      ToAmount: 0,
      Type: "",
      Limit: 500,
      Skip: 0,
    };
    dispatch(getAllTopupRequests(payload));
  };

  const handleClear = () => {
    const updatedFilters = {
      fromDate: firstDay,
      toDate: today,
      status: "",
    };
    setFilters(updatedFilters);
    handleView(updatedFilters);
  };

  const formatDate = (dateString: string) => {
    return dateString
      ? moment(dateString, "DD/MM/YYYY").format("DD MMM YYYY")
      : "-";
  };

  return (
    <div className="container py-5">
      <div className="d-flex align-items-center mb-4">
        <button
          onClick={() => navigate(-1)}
          className="btn btn-link me-3"
          style={{ color: "#00a34d", background: "white", padding: "8px" }}
        >
          <FaArrowLeft size={20} />
        </button>
        <h2 className="mb-0">Top-Up Request</h2>
      </div>
      <TopupReqDelete
        ID={deleteID}
        searchPayload={{
          FromDate: filters.fromDate || null,
          ToDate: filters.toDate || null,
          RequestStatus: filters.status || "",
          MobileNo: localStorage.getItem("mobile_no") || "",
          DepositedBank: "",
          Name: "",
          FromAmount: 0,
          ToAmount: 0,
          Type: "",
          Limit: 500,
          Skip: 0,
        }}
      />

      {/* ---------- SUMMARY CARDS ---------- */}
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body py-3">
          <div className="row g-3 align-items-stretch text-center">
            {/* Limit Given */}
            <div className="col-md-3 col-sm-6">
              <div
                className="d-flex flex-column justify-content-center align-items-center rounded shadow-sm py-2 h-100"
                style={{ background: "#fffbe6", border: "1px solid #f1e48a" }}
              >
                <div className="d-flex align-items-center gap-2 mb-1">
                  <FaCoins color="#d4b000" size={18} />
                  <span className="fw-semibold text-dark small">
                    Limit Given
                  </span>
                </div>
                <span className="fw-bold text-dark fs-6">
                  ₹
                  {(walletDetails?.CreditLimit || 0)?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                  })}
                </span>
              </div>
            </div>

            {/* Wallet Balance */}
            <div className="col-md-3 col-sm-6">
              <div
                className="d-flex flex-column justify-content-center align-items-center rounded shadow-sm py-2 h-100"
                style={{ background: "#e7f7ed", border: "1px solid #b5e3c2" }}
              >
                <div className="d-flex align-items-center gap-2 mb-1">
                  <FaWallet color="#00a34d" size={18} />
                  <span className="fw-semibold text-dark small">
                    Wallet Balance
                  </span>
                </div>
                <span className="fw-bold text-success fs-6">
                  ₹
                  {(walletDetails?.wallet_balance || 0)?.toLocaleString(
                    "en-IN",
                    {
                      minimumFractionDigits: 2,
                    }
                  )}
                </span>
              </div>
            </div>

            {/* Outstanding Amount */}
            <div className="col-md-3 col-sm-6">
              <div
                className="d-flex flex-column justify-content-center align-items-center rounded shadow-sm py-2 h-100"
                style={{ background: "#fdeaea", border: "1px solid #f5b5b5" }}
              >
                <div className="d-flex align-items-center gap-2 mb-1">
                  <FaExclamationCircle color="#e63946" size={18} />
                  <span className="fw-semibold text-dark small">
                    Outstanding
                  </span>
                </div>
                <span className="fw-bold text-danger fs-6">
                  ₹
                  {(walletDetails?.OutStandingAmount || 0)?.toLocaleString(
                    "en-IN",
                    {
                      minimumFractionDigits: 2,
                    }
                  )}
                </span>
              </div>
            </div>

            {/* Add New Topup Button */}
            <div className="col-md-3 col-sm-6">
              <button
                className="btn w-100 h-100 fw-semibold d-flex justify-content-center align-items-center shadow-sm"
                style={{
                  backgroundColor: "rgba(205, 200, 36, 1)",
                  color: "#000",
                  borderRadius: "10px",
                  fontSize: 15,
                }}
                onClick={() => navigate("/topuprequest/add")}
              >
                <FaPlusCircle className="me-2" />
                Add New Topup
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- FILTER SECTION ---------- */}
      <div className="card shadow-sm border-0 mb-4">
        <div className="card-body row g-3 align-items-end">
          <div className="col-md-3">
            <label className="form-label text-sm fw-bold">From Date</label>
            <input
              type="date"
              name="fromDate"
              className="form-control form-control-sm"
              value={filters.fromDate}
              onChange={handleFilterChange}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label text-sm fw-bold">To Date</label>
            <input
              type="date"
              name="toDate"
              className="form-control form-control-sm"
              value={filters.toDate}
              onChange={handleFilterChange}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label text-sm fw-bold">Status</label>
            <select
              name="status"
              className="form-select form-select-sm"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">All</option>
              <option value="Pending">Pending</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>

          <div className="col-md-3 d-flex gap-2">
            <button
              className="btn flex-fill"
              style={{
                backgroundColor: "rgba(205, 200, 36, 1)",
                color: "#000",
                fontWeight: 600,
              }}
              onClick={() => handleView(filters)}
            >
              <FaEye className="me-1" /> View
            </button>
            <button
              className="btn btn-secondary flex-fill"
              style={{ fontWeight: 600 }}
              onClick={handleClear}
            >
              Clear
            </button>
          </div>
        </div>
      </div>

      {/* ---------- TABLE SECTION ---------- */}
      <div className="card border-0 shadow-sm">
        <div className="card-body p-0">
          {loading ? (
            <div className="text-center py-4">
              <div
                className="spinner-border"
                style={{ color: "rgba(205, 200, 36, 1)" }}
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table align-items-center mb-0">
                <thead
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #dee2e6",
                  }}
                >
                  <tr>
                    <th className="text-uppercase text-dark text-xs ps-4 py-3">
                      No
                    </th>
                    <th
                      className="text-uppercase text-dark text-xs py-3"
                      style={{ width: "120px" }}
                    >
                      Date
                    </th>
                    <th className="text-uppercase text-dark text-xs py-3">
                      Name
                    </th>
                    <th className="text-uppercase text-dark text-xs py-3">
                      Mobile No
                    </th>
                    <th className="text-uppercase text-dark text-xs py-3">
                      Deposited Bank
                    </th>
                    <th className="text-uppercase text-dark text-xs py-3">
                      Amount (₹)
                    </th>
                    <th className="text-uppercase text-dark text-xs py-3">
                      Type
                    </th>
                    <th className="text-uppercase text-dark text-xs py-3">
                      Status
                    </th>
                    <th
                      className="text-uppercase text-dark text-xs py-3"
                      style={{ width: "200px" }}
                    >
                      Remarks
                    </th>
                    <th
                      className="text-uppercase text-dark text-xs py-3 text-center"
                      style={{ width: "80px" }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {topups?.length > 0 ? (
                    topups.map((item: any, index: number) => (
                      <tr key={item.ID}>
                        <td className="ps-4 align-middle">
                          <p className="text-xs mb-0">{index + 1}</p>
                        </td>
                        <td className="align-middle">
                          <p className="text-xs mb-0">
                            {formatDate(item.TransactionDate)}
                          </p>
                        </td>
                        <td className="align-middle">
                          <p className="text-xs mb-0">{item.Name}</p>
                        </td>
                        <td className="align-middle">
                          <p className="text-xs mb-0">{item.MobileNo}</p>
                        </td>
                        <td className="align-middle">
                          <p className="text-xs mb-0">
                            {item.DepositedBank || "-"}
                          </p>
                        </td>
                        <td className="align-middle">
                          <p className="text-xs mb-0">
                            {item?.Amount?.toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                            })}
                          </p>
                        </td>
                        <td className="align-middle">
                          <p className="text-xs mb-0">{item.Type || "-"}</p>
                        </td>
                        <td className="align-middle">
                          <span
                            className="badge text-white"
                            style={{
                              backgroundColor:
                                item.RequestStatus === "Pending"
                                  ? "goldenrod"
                                  : item.RequestStatus === "Rejected"
                                  ? "lightcoral"
                                  : "#00a34de6",
                              fontSize: 12,
                            }}
                          >
                            {item.RequestStatus}
                          </span>
                        </td>
                        <td
                          className="align-middle"
                          style={{ maxWidth: "220px" }}
                        >
                          <p className="text-xs mb-0">
                            <ExpandableText text={item.Remarks || "-"} />
                          </p>
                        </td>
                        <td className="align-middle ">
                          <div className="d-flex gap-3 align-items-center">
                            <FaEye
                              size={22}
                              className="text-primary"
                              style={{ cursor: "pointer" }}
                              title="View"
                              onClick={() => {
                                navigate("/topuprequest/view", {
                                  state: {
                                    ID: item?.ID,
                                  },
                                });
                              }}
                            />
                            {item.RequestStatus === "Pending" && (
                              <FaTrash
                                size={16}
                                className="text-danger"
                                style={{ cursor: "pointer" }}
                                title="Delete"
                                data-bs-toggle="modal"
                                data-bs-target="#topuprequestdelete"
                                onClick={() => setDeleteID(item?.ID)}
                              />
                            )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} className="text-center py-4">
                        <p className="text-sm text-muted mb-0">
                          No topup records found
                        </p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topup;
